import { Text } from 'react-native-paper';
import { View } from 'react-native';
import { useAppTheme } from '../theme';

interface ChipProps {
  status: 'New' | 'Active' | 'Closed';
}

export default function Chip({ status }: ChipProps) {
  const theme = useAppTheme();

  function getStatusColor(status: 'New' | 'Active' | 'Closed') {
    let color = theme.colors.openMarkerColor;

    if (status === 'Closed') {
      color = theme.colors.closedMarkerColor;
    } else if (status === 'Active') {
      color = theme.colors.activeMarkerColor;
    }

    return color;
  }

  return (
    <View
      style={{
        borderRadius: 50,
        margin: 4,
        paddingRight: 6,
        paddingLeft: 6,
        paddingBottom: 2,
        paddingTop: 2,
        backgroundColor: getStatusColor(status),
      }}
    >
      <Text variant="labelSmall">{status}</Text>
    </View>
  );
}
